// MCM-1093 Added new class for Club ratings
export class ClubWithRatings{
    constructor(clubRatingId:string = null, name:string = null){
        this.ClubRatingId = clubRatingId;
        this.Name = name;
    }
    public ClubId:string;

    public OrgNodeId:string;
    
    public Name:string;
    
    public ClubGroupName:string;
    
    public ClubRatingId:string;
    
    public Rating:number;

    public FiscalYearId:number;

    public HasGovernorVisited:boolean;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/club-with-ratings.ts